// extracted by mini-css-extract-plugin
export default {"column2":"Facilitator_column2__4tZDK","loading":"Facilitator_loading__ZRCRS","badges":"Facilitator_badges__mt7PH"};